<template>
  <div class="wrap">
    <div class="item" >
      <div class="title">
        <span class="title-text">项目效果图</span>
      </div>
      <div class="img-wrap">
        <div v-if="!imgList['项目效果图']" class="nodata">
          <img style="padding-top: 4.1rem;width: 6.47rem;height: 6.47rem;" src="@/assets/image/index/暂无数据@2x.png" />
          <span class="nodata-text">暂无数据</span>
        </div>
        <el-carousel v-else height="100%" style="width: 100%;height: 100%;" >
            <el-carousel-item v-for="item in imgList['项目效果图']" :key="item">
             <img :src="item.url" @click="handleImageClick(imgList['项目效果图'])" class="carousel-image" />
            </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="item" >
      <div class="title">
        <span class="title-text">总平面布置图</span>
      </div>
      <div class="img-wrap">
        <div v-if="!imgList['总平面布置图']" class="nodata">
          <img style="padding-top: 4.1rem; width: 6.47rem;height: 6.47rem;" src="@/assets/image/index/暂无数据@2x.png" />
          <span class="nodata-text">暂无数据</span>
        </div>
        <el-carousel v-else height="100%" style="width: 100%;height: 100%;" >
            <el-carousel-item v-for="item in imgList['总平面布置图']" :key="item">
             <img  :src="item.url" @click="handleImageClick(imgList['总平面布置图'])" class="carousel-image" />
            </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <div class="item" >
      <div class="title">
        <span class="title-text">无人机航拍</span>
      </div>
      <div class="img-wrap">
        <div v-if="!imgList['无人机航拍']" class="nodata">
          <img style="padding-top: 4.1rem;width: 6.47rem;height: 6.47rem;" src="@/assets/image/index/暂无数据@2x.png" />
          <span class="nodata-text">暂无数据</span>
        </div>
        <el-carousel v-else height="100%" style="width: 100%;height: 100%;" >
            <el-carousel-item v-for="item in imgList['无人机航拍']" :key="item">
             <img  :src="item.url" @click="handleImageClick(imgList['无人机航拍'])" class="carousel-image" />
            </el-carousel-item>
        </el-carousel>
      </div>
    </div>



  </div>
</template>
<script>
import {getProjectImg} from '@/utils/indexApi'
export default{
  inject: ["clickshowBigImg"],
  data(){
    return{
      imgList:{
        '效果图':[{
          image:require('@/assets/image/menu2.png')
        }],
      },
      dialogVisible: false, // 控制对话框显示
      enlargedImageUrl: '', // 放大的图片URL
    }
  },
  created(){
    this.getImg()
  },
  methods:{
    handleImageClick(imgList) {

     this.clickshowBigImg(imgList)
    },
    getImg(){
      let section = sessionStorage.getItem('currentSection')
      var sectionId = '' ;
      if(section){
        var setcionJSON = JSON.parse(section)
        sectionId = setcionJSON.id;
      }
      getProjectImg(sectionId).then(res=>{
        this.imgList = res.data
      })
    }
  }
}
</script>
<style scoped lang="scss">


.nodata{
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  background: #264461;
  border-radius: 8px;
  .nodata-text{
    font-family: AlibabaPuHuiTi_2_65_Medium;
    font-size: 14px;
    color: rgba(255,255,255,0.8);
    line-height: 20px;
    text-align: justify;
    font-style: normal;
    text-transform: none;
  }
}

.wrap{
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 28px;
  .item{
    .title{
      width: 19.06rem;
      height: 26px;
      background: url('@/assets/image/index/二级标题-背景@2x.png') ;
      background-size: contain;
      background-repeat: no-repeat;
      .title-text{
        margin-left: 32px;
        font-family: AlibabaPuHuiTi_2_75_SemiBold;
        font-size: 1.46rem;
        color: #D1D6DF;
        line-height: 18px;
        text-align: left;
        font-style: normal;
      }
    }
    .img-wrap{
      width: 29.91rem ;
      height: 17.78rem;
      margin-top: 16px;

    }
  }
}
img{
  width: 100%;
  height: 100%;
}
</style>
